var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"8","viewBox":"0 0 10 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.1875 4L1.5 2.6875L3.6875 4.875L8.5 0.0625L9.8125 1.375L3.6875 7.5L0.1875 4Z","fill":"#FFFFFF"}})])}
var staticRenderFns = []

export { render, staticRenderFns }